import { render, staticRenderFns } from "./ClientFiles.vue?vue&type=template&id=cfb16b98&"
import script from "./ClientFiles.vue?vue&type=script&lang=js&"
export * from "./ClientFiles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports